import React from 'react';
import classNames from 'classnames';
import { BodyM } from 'components/Typography/Typography';
import styles from 'assets/jss/material-dashboard-pro-react/views/accounts/detailsRowStyle';
import { makeStyles } from '@material-ui/core';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IDetailsRowProps {
	label: string;
	value?: string | React.ReactElement | null;
	hideBorder?: boolean;
}

const DetailsRow = ({ label, value, hideBorder }: IDetailsRowProps) => {
	const classes = useStyles();

	return (
		<div className={classNames(classes.row, { [classes.rowBorder]: !hideBorder })}>
			<BodyM color="disabled-light">{label}</BodyM>
			<BodyM color="primary-light">{value}</BodyM>
		</div>
	);
};

export default DetailsRow;
